import { Box, Stack } from "@mui/material";
import { CPButton, CPTitle } from "@warden-ui/common-components";
import { CPTextField } from "@warden-ui/common-components";
import { useState } from "react";
import { CPFormHelperText } from "@warden-ui/common-components";
import { CPCard } from "@warden-ui/common-components";
import { isValidPassword, passwordValidations } from "@warden-ui/common";
import { useTranslation } from "react-i18next";

interface CardContentResetPasswordSubmitProps {
  email: string;
  teamDomain: string;
  onClickResetPassword?: (password: string) => void;
  errorMessage?: string;
  loading?: boolean;
}

export const CardContentResetPasswordSubmit = ({
  email,
  teamDomain,
  onClickResetPassword = () => {},
  ...props
}: CardContentResetPasswordSubmitProps ) => {
  const [ t ] = useTranslation();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const matchPassword = password === confirmPassword;

  const validPassword = () => {
    return matchPassword && isValidPassword(password);
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (validPassword()) {
      onClickResetPassword(password);
    }
  };

  return (
    <CPCard>
      <CPTitle
        className="mb-4"
        title={t('change_password.title')}
        hint={t('change_password.hint')}
      />

      <form onSubmit={handleSubmit} className="w-100">
        <Box className="card-row w-100">
          <Stack spacing={2}>
            <Box>
              <CPTextField
                id="password"
                label={t('labels.password')}
                value={password}
                type="password"
                onChange={(val) => setPassword(val)}
                sx={{ mb: 0.5}}
              />

              {passwordValidations.map((validation) => (
                <CPFormHelperText
                  key={validation.name}
                  id={`${validation.name}-helper`}
                  message={validation.message} error={!validation.isValid(password)}
                />
              ))}
            </Box>

            <CPTextField
              id="confirm-password"
              label={t('labels.confirm_password')}
              value={confirmPassword}
              type="password"
              autoFocus={false}
              onChange={(val) => setConfirmPassword(val)}
              errorMessage={matchPassword? props.errorMessage : t('errors.password_mismatch')}
            />
          </Stack>
        </Box>
        <Box className="card-row w-100">
          <CPButton
            label={t('buttons.change_password')}
            loading={props.loading}
            disabled={!validPassword()}
          />
        </Box>
      </form>
    </CPCard>
  );
};
